/* Pegatinas · dónde va a cortar el plóter · Imprimirlo
 *
 * Reproduce en el navegador lo que hace pegatinas.py en producción, para que
 * el cliente vea la pegatina como le va a llegar antes de pagar:
 *
 *   - Borde blanco de 3 mm alrededor del dibujo (BORDE en pegatinas.py).
 *   - En troqueladas el corte sigue la silueta del canal alfa, engordada
 *     esos 3 mm; en redondas y cuadradas es el círculo o el rectángulo
 *     redondeado del formato elegido.
 *   - Zona de seguridad de 2 mm por dentro del corte: el plóter calibrado
 *     se va 0,2 mm, pero un diseño pegado al filo se ve mal aunque salga bien.
 *
 * Aquí no se decide nada de producción: solo se dibuja y se avisa.
 */
(function () {
  'use strict';

  var BORDE = 5;        // mm de borde blanco COMO MÁXIMO
  var BORDE_MIN = 2;    // por debajo de esto la cuchilla roza la tinta
  var SEGURIDAD = 2;    // mm que se dejan libres por dentro del corte

  /* LAS CHAPAS NO SON UNA PEGATINA REDONDA: el diámetro que ve el cliente
     («chapa de 38 mm») NO es lo que hay que imprimir. La lámina se prensa
     envolviendo el disco metálico, así que el papel impreso tiene que ser
     más grande —ese sobrante se pliega por detrás, invisible— y encima hay
     una zona segura interior para el texto, más estrecha todavía, porque
     cerca del pliegue la imagen se deforma un poco. Estos números son de la
     ficha real del proveedor (Xavi, 28/09, plantilla de chapas): por
     diámetro, {corte: mm de la lámina a imprimir, limite: mm de la zona
     segura de texto/diseño}. No es una fórmula ni un porcentaje —cada molde
     de la prensa tiene los suyos—, así que se busca por tabla, no se
     calcula. */
  var CHAPA_MEDIDAS = {
    25: { corte: 34, limite: 22 },
    31: { corte: 41, limite: 28 },
    38: { corte: 51, limite: 34 },
    50: { corte: 61.5, limite: 46 },
    59: { corte: 70, limite: 55 },
    75: { corte: 87, limite: 70 }
  };
  // por si algún día hay una medida sin ficha: un margen parecido al de las de al lado
  function chapaMedidas(diametro) {
    if (CHAPA_MEDIDAS[diametro]) return CHAPA_MEDIDAS[diametro];
    return { corte: diametro + 12, limite: diametro - 5 };
  }

  /* EL BORDE BLANCO VA EN PROPORCIÓN. Cinco milímetros en una pegatina de
     10 cm no se notan; en una de 3 cm son el 33 % del ancho y la pegatina
     parece un huevo frito. Se usa el 3 % del lado mayor, con tope arriba (5 mm,
     que es lo que hace el panel) y suelo abajo (2 mm, que es lo que necesita
     el plóter para no comerse la tinta).
       hasta 6 cm -> 2,0 mm · 10 cm -> 3,0 · 15 cm -> 4,5 · desde 17 cm -> 5,0  */
  function bordePara(formato) {
    var lado = Math.max(formato.w || 0, formato.h || 0);
    return Math.min(BORDE, Math.max(BORDE_MIN, Math.round(lado * 0.03 * 10) / 10));
  }

  /* CUÁNTAS CABEN EN UNA HOJA.
   *
   * La unidad de este taller no es la pegatina, es la HOJA: el minuto de
   * cargarla y el pliego se pagan igual lleven una pegatina o setenta. Por eso
   * el plazo se calcula en hojas y no en unidades — mil de 3 cm son 13 hojas y
   * mil de 10 cm son 167, y prometerles la misma fecha es mentir en una de las
   * dos.
   *
   * Los números salen de la SRA3 útil, 290 × 420 mm, con 5,5 mm de paso entre
   * pegatina y pegatina. No es una constante elegida a ojo: es la que reproduce
   * exactamente las cuatro cuentas que hizo Xavi con hojas de verdad —77 de
   * 3 cm, 28 de 5, 12 de 8 y 6 de 10—. Si alguien la cambia, `hoja.js` falla.
   */
  var UTIL_W = 290, UTIL_H = 420, PASO = 5.5;

  function porHoja(cutW, cutH) {
    function caben(w, h) {
      if (!(w > 0) || !(h > 0)) return 0;
      return Math.floor(UTIL_W / (w + PASO)) * Math.floor(UTIL_H / (h + PASO));
    }
    return Math.max(caben(cutW, cutH), caben(cutH, cutW));
  }

  /* Del texto de la opción al formato:
       "Redonda 5cm"          -> redonda, 50 × 50 mm
       "Rectangular 8x5cm"    -> cuadrada, 80 × 50 mm
       "Mediana hasta 6×6cm"  -> libre, máximo 60 × 60 mm
       "31mm"                 -> redonda, 31 × 31 mm (chapas: solo hay
                                  redondas, así que no hace falta decirlo,
                                  y la medida viene en mm, no en cm) */
  function formatoDe(texto) {
    var t = String(texto || '');
    var redonda = /redond/i.test(t);
    var recta = /cuadrad|rectangul/i.test(t);
    var dos = t.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm/i);
    if (dos) {
      return {
        w: parseFloat(dos[1].replace(',', '.')) * 10,
        h: parseFloat(dos[2].replace(',', '.')) * 10,
        forma: redonda ? 'redonda' : (recta ? 'cuadrada' : 'libre')
      };
    }
    var uno = t.match(/(\d+(?:[.,]\d+)?)\s*cm/i);
    if (uno && redonda) {
      var d = parseFloat(uno[1].replace(',', '.')) * 10;
      return { w: d, h: d, forma: 'redonda' };
    }
    var mm = t.match(/^\s*(\d+(?:[.,]\d+)?)\s*mm\s*$/i);
    if (mm) {
      var dmm = parseFloat(mm[1].replace(',', '.'));
      return { w: dmm, h: dmm, forma: 'redonda' };
    }
    return null;
  }

  /* El color de fondo de un diseño opaco, si lo tiene: el de su marco. Si el marco
     es un color liso (póster, logo sobre fondo de color) se devuelve para rellenar
     el imán hasta el filo sin dejar margen blanco; si es una foto (cambia mucho de
     un punto a otro) o es blanco, no hay nada que rellenar y se devuelve null. */
  function colorUniforme(arte) {
    try {
      if (!arte) return null;
      var k = 64 / Math.max(arte.width, arte.height);
      var w = Math.max(8, Math.round(arte.width * k)), h = Math.max(8, Math.round(arte.height * k));
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(arte, 0, 0, w, h);
      var d = x.getImageData(0, 0, w, h).data, n = 0, sr = 0, sg = 0, sb = 0, i, j;
      var banda = Math.max(1, Math.round(Math.min(w, h) * 0.05)), px = [];
      for (j = 0; j < h; j++) for (i = 0; i < w; i++) {
        if (i < banda || j < banda || i >= w - banda || j >= h - banda) {
          var o = (j * w + i) * 4;
          if (d[o + 3] < 200) return null;                // el marco es transparente: no hay fondo
          px.push([d[o], d[o + 1], d[o + 2]]); sr += d[o]; sg += d[o + 1]; sb += d[o + 2]; n++;
        }
      }
      if (!n) return null;
      var mr = sr / n, mg = sg / n, mb = sb / n, v = 0;
      for (i = 0; i < px.length; i++) v += Math.pow(px[i][0] - mr, 2) + Math.pow(px[i][1] - mg, 2) + Math.pow(px[i][2] - mb, 2);
      var desv = Math.sqrt(v / (3 * n));
      if (desv > 26) return null;                          // una foto, no un color liso
      if (mr > 244 && mg > 244 && mb > 244) return null;   // blanco: ya es el del imán
      return 'rgb(' + Math.round(mr) + ',' + Math.round(mg) + ',' + Math.round(mb) + ')';
    } catch (e) { return null; }
  }

  /* Cuánto se puede hacer el dibujo dentro de ese formato, y qué avisar.
     px: [ancho, alto] del dibujo ya recortado. */
  function plan(formato, px, opciones) {
    var o = opciones || {};
    /* IMANES: sin borde blanco ni de color, tampoco en «a tu forma» (Xavi, 01/10): el
       corte va pegado a la silueta. Quedan 0,3 mm solo para que el contorno sea una
       curva calculable; no se ve. */
    /* ACTUALIZADO (Xavi, 01/10): el borde blanco es una OPCIÓN, sea cual sea la forma. Por
       defecto sin borde; con borde, el grosor lo elige el cliente. */
    var borde = o.iman ? (o.filete ? (o.borde == null ? bordePara(formato) : o.borde) : 0.3)
      : (o.borde == null ? bordePara(formato) : o.borde);
    var seg = o.seguridad == null ? SEGURIDAD : o.seguridad;
    var prop = px[1] / px[0];
    var r = { forma: formato.forma, borde: borde, seguridad: seg, avisos: [] };

    /* MOVER EL DISEÑO DENTRO DE LA CHAPA (Xavi, 28/09). Es un desplazamiento
       en mm sobre el centrado de siempre, puesto por el cliente arrastrando
       el lienzo — aquí solo se recoge y se limita a no perderse de vista del
       todo; quien lo pinta es dibujar(). */
    r.offX = Math.max(-formato.w, Math.min(formato.w, o.panX || 0));
    r.offY = Math.max(-formato.h, Math.min(formato.h, o.panY || 0));

    /* A SANGRE O CON BLANCO ALREDEDOR.
       En redonda y cuadrada la pegatina es SIEMPRE redonda o cuadrada; lo que
       cambia es cómo se coloca el dibujo dentro:
         - Archivo con fondo (una foto, un diseño sobre un rectángulo de color)
           en REDONDA: se hace grande hasta TAPAR el círculo entero y lo que
           sobra se corta. Meter un rectángulo dentro de un círculo blanco no
           es lo que nadie pide cuando elige redonda, y ahí siempre se pierden
           las cuatro esquinas.
         - El mismo archivo en CUADRADA: se ajusta para que quepan alto y
           ancho a la vez, sin recortar nada. Aquí sí hay esquinas que llenar
           con blanco (o con el color elegido) si el formato es más alargado
           que el diseño, y es preferible a comerse el diseño al cambiar de
           una cuadrada a una rectangular muy alargada.
         - Archivo recortado (PNG transparente): se centra dentro con el blanco
           del vinilo alrededor, que es la pegatina de logo de toda la vida.
       Si va a sangre EN REDONDA se avisa de cuánto se pierde, porque ahí son
       las esquinas y suele estar el año o el nombre.

       LAS CHAPAS (o.chapa) NO TIENEN ESTA ELECCIÓN: no hay vinilo ni borde
       que elegir, se prensa el disco entero, así que siempre van a sangre —
       Xavi, 28/09: «sí, siempre a sangre», al migrarlas de Qstomizer. */
    /* IMANES: rectangulares y redondos no llevan margen blanco (Xavi, 01/10): el
       diseño llena la forma hasta el filo. Con un archivo con fondo tapa la forma
       (y el cliente puede encoger o mover la imagen); con un logo recortado se
       ajusta entero, sin margen. Solo «a tu forma» sigue con su borde de troquel. */
    /* ACTUALIZADO (Xavi, 01/10, mismo día): «la parte de tinta del diseño debe quedar
       por dentro de la zona de seguridad», tanto en cuadrado como en redondo. Así
       que el dibujo NO se agranda hasta tapar la forma: entra entero dentro de la
       zona segura (2 mm del filo) y, si el diseño trae un color de fondo liso, ese
       color llena el imán hasta el borde para que no quede margen blanco. */
    /* FONDO INTELIGENTE EN PEGATINAS (o.libre, las tres fichas a medida): con un diseño con fondo
       (opaco) pasa lo mismo que en los imanes: entra entero en la zona segura y el color liso
       de su fondo llena la pegatina hasta el filo. Con un logo recortado, el de siempre. */
    var iman2 = (!!o.iman || (!!o.libre && o.transparente === false)) && formato.forma !== 'libre';
    var colorIm = iman2 && o.transparente === false ? (o.fondoColor || colorUniforme(o.arte)) : null;
    var sangra = !iman2 && (o.transparente === false || !!o.chapa);

    /* EL BORDE BLANCO ES UNA ELECCIÓN, no una consecuencia. Con un archivo que
       tapa la pegatina entera hay dos pegatinas buenas y distintas: la de
       sangre, en la que el dibujo llega al filo, y la de toda la vida, con el
       filete blanco del vinilo alrededor. Antes salía una u otra según el
       archivo; ahora lo elige el cliente y lo ve. */
    var filete = ((sangra && o.filete && !o.iman) || (iman2 && o.filete)) ? borde : 0;
    // con borde, la zona de seguridad empieza donde acaba el borde: la línea punteada se mueve hacia dentro con el grosor
    if (iman2) r.seguridad = Math.max(seg, filete);

    /* EL MARGEN DEL LOGO/FOTO RECORTADA TAMBIÉN LO ELIGE EL CLIENTE. Antes era
       fijo a la zona de seguridad (2 mm); ahora, si lo ha tocado, se respeta
       (mismo rango que el filete de las que sangran: BORDE_MIN a BORDE). Sin
       tocar nada sigue siendo la seguridad de siempre. */
    var margenLogo = (!sangra && o.borde != null && !o.iman && !iman2)
      ? Math.min(BORDE, Math.max(BORDE_MIN, o.borde)) : seg;

    /* DÓNDE ESTÁ EL CENTRO DEL DIBUJO. No es el centro del archivo: casi
       ningún diseño viene centrado de verdad —sobra aire arriba, o el rótulo
       baja hasta el filo—, y en una redonda eso se paga caro porque el círculo
       se come las esquinas. Se centra por lo que hay DIBUJADO, y para que el
       círculo siga tapado hay que agrandar el dibujo tanto como se ha movido:
       si el centro está al 40 %, solo el 80 % del ancho sirve para tapar. */
    var ccx = o.centro ? o.centro[0] : 0.5, ccy = o.centro ? o.centro[1] : 0.5;
    var usaX = Math.max(0.45, 2 * Math.min(ccx, 1 - ccx));
    var usaY = Math.max(0.45, 2 * Math.min(ccy, 1 - ccy));

    /* CUANDO EL DISEÑO TRAE SU PROPIO FONDO DE COLOR, ESE FONDO ES EL QUE
     * SANGRA, NO EL DIBUJO.
     *
     * Un emblema sobre negro metido en una redonda se agrandaba hasta tapar el
     * círculo, y el círculo le cortaba las esquinas: se comía las letras de
     * arriba. Xavi, viéndolo: «se come la letra, debería dejar más negro en
     * este caso». Exacto — hay negro de sobra, y estirar el negro no cuesta
     * nada, mientras que recortar el dibujo cuesta el dibujo.
     *
     * Así que con fondo de color se rellena la pegatina entera de ese color y
     * el dibujo va DENTRO, completo. Sigue saliendo llena de tinta hasta el
     * filo —que es lo que se pide al elegir «a sangre»— y no se pierde nada.
     *
     * EN CHAPAS NO: aquí ya se ajusta para que quepa entero (y el cliente
     * tiene zoom y arrastre para lo que quiera hacer más grande o mover), así
     * que este relleno automático solo estorbaría —y si se colara, el zoom y
     * el arrastre dejarían de aplicarse sin que se notara por qué. */
    var rellena = (sangra && !!o.fondoColor && !!o.mascara && !o.chapa && !o.iman) || !!colorIm;

    if (formato.forma === 'redonda') {
      r.cutW = r.cutH = Math.min(formato.w, formato.h);
      /* CHAPAS: el diámetro elegido (25/31/38…) es lo que se VE, no lo que
         se imprime. r.cutW sigue siendo el diámetro —de ahí sale el
         encaje/zoom del dibujo, que es sobre lo visible—, pero el archivo
         real hay que prepararlo más grande (r.corteChapa) y el texto tiene
         que quedarse dentro de una zona más estrecha (r.limiteChapa). */
      if (o.chapa) {
        var medidasCh = chapaMedidas(Math.round(r.cutW));
        r.corteChapa = medidasCh.corte;
        r.limiteChapa = medidasCh.limite;
      }
      if (sangra && !rellena) {
        var dentro0 = r.cutW - 2 * filete;
        /* LAS CHAPAS QUIEREN EL DIBUJO ENTERO, NO TAPAR A LA FUERZA — Xavi,
           28/09: «que adapte ancho y largo para que entre toda». En pegatinas
           cubrir entero tiene sentido (si no, las esquinas del círculo se
           quedan blancas y nadie lo pidió así), pero en una chapa el cliente
           quiere ver su diseño completo, así que aquí se ajusta para que
           quepa (Math.min), no para que tape (Math.max). Encima, un zoom
           opcional (o.zoom, 1 = cabe entero) deja que el propio cliente
           decida si lo quiere más grande —aunque se recorte algo— o más
           pequeño con aire alrededor. */
        var kBase = (o.chapa || (o.iman && o.transparente !== false))
          ? Math.min(dentro0 / (px[0] * usaX), dentro0 / (px[1] * usaY))
          : Math.max(dentro0 / (px[0] * usaX), dentro0 / (px[1] * usaY));
        var zoom = ((o.chapa || o.iman || o.libre) && o.zoom) ? Math.max(0.4, Math.min(2.5, o.zoom)) : 1;
        var k0 = kBase * zoom;
        r.arteW = px[0] * k0; r.arteH = px[1] * k0;
        r.sangra = true; r.filete = filete; r.centro = [ccx, ccy];
      } else {
        /* EL DIBUJO ENTERO DENTRO DEL CÍRCULO DE SEGURIDAD.
         *
         * Lo que manda no es el lado del archivo, es hasta dónde llega la TINTA
         * medida desde el centro. Antes se usaba la diagonal del rectángulo, o
         * sea se metía un CUADRADO dentro del círculo, y con un logo redondo
         * —que es la mitad de los que llegan a una pegatina redonda— eso deja
         * un 30 % del diámetro tirado: un escudo circular salía a 3,3 cm en una
         * pegatina de 5 cm, rodeado de un anillo blanco de 8,5 mm.
         *
         * `radioMax` devuelve hasta dónde llega la tinta en tanto por uno de la
         * media diagonal: 1 en un diseño que llena las esquinas, 0,71 en uno
         * redondo. Con eso, el cuadrado sigue saliendo exactamente igual que
         * antes y el redondo llena la pegatina. */
        var d = r.cutW - 2 * (iman2 ? Math.max(margenLogo, filete) : margenLogo + (rellena ? filete : 0));
        /* El alcance de la tinta se mide sobre la MÁSCARA cuando la hay: en un
           archivo opaco el alfa está lleno y no diría nada. */
        var u = (o.mascara || o.arte) ? radioMax(o.mascara || o.arte) : 1;
        var diag = Math.sqrt(1 + prop * prop);
        r.arteW = d / (diag * u);
        r.arteH = r.arteW * prop;
        if ((o.iman || o.libre) && o.zoom) { var zI = Math.max(0.4, Math.min(2.5, o.zoom)); r.arteW *= zI; r.arteH *= zI; }
        /* El blanco que queda alrededor es entonces ese margen (la seguridad
           de siempre, o el que haya elegido el cliente), no el borde de las
           troqueladas: si no se dice así, la ficha promete 2,5 mm y se ven 8,5. */
        r.borde = margenLogo;
        if (iman2 && filete) r.filete = filete;
        if (rellena) {
          /* Lo que rodea al dibujo es su propio fondo, no blanco del vinilo.
             El filete sí se respeta si el cliente lo ha pedido: entonces el
             fondo llena hasta ahí y el anillo blanco queda por fuera. */
          r.relleno = colorIm || o.fondoColor; r.borde = filete; r.sangra = true; r.filete = filete;
          r.centro = [ccx, ccy];
        }
        /* El círculo penaliza a los diseños alargados: cuanto más lejos del
           cuadrado, más aire sobra a los lados. A un logo cuadrado no le pasa
           nada, así que ahí no se avisa de nada. */
        var rel = Math.max(prop, 1 / prop);
        if (rel >= 1.6) {
          r.avisos.push({ tipo: 'forma', texto: 'Tu diseño es alargado y en ' + (o.iman ? 'un imán redondo' : 'una pegatina redonda') + ' ' +
            'queda sobrando mucho aire arriba y abajo. En el formato rectangular saldría bastante más grande ' +
            'por el mismo dinero.' });
        }
      }
    } else if (formato.forma === 'cuadrada') {
      r.cutW = formato.w; r.cutH = formato.h;
      if (sangra && !rellena) {
        /* AQUÍ NO SE RECORTA: se ajusta para que quepan ALTO Y ANCHO a la vez.
           En un círculo cubrir entero tiene sentido (si no, las esquinas se
           quedan blancas), pero en un rectángulo cubrir entero es peligroso:
           si el cliente pasa de una pegatina cuadrada a una muy alargada, el
           diseño se agranda para tapar el lado largo y se come casi todo el
           corto — Xavi, 28/09: «se corta toda». Con Math.min el diseño
           siempre entra completo; lo que sobra alrededor lo llena el vinilo
           (o el color elegido), igual que en el logo. */
        var k1 = (o.iman && o.transparente === false)
          ? Math.max((r.cutW - 2 * filete) / (px[0] * usaX), (r.cutH - 2 * filete) / (px[1] * usaY))
          : Math.min((r.cutW - 2 * filete) / (px[0] * usaX), (r.cutH - 2 * filete) / (px[1] * usaY));
        // imanes: el cliente puede agrandar la imagen o encogerla (y moverla) dentro de la forma
        if ((o.iman || o.libre) && o.zoom) k1 *= Math.max(0.4, Math.min(2.5, o.zoom));
        r.arteW = px[0] * k1; r.arteH = px[1] * k1;
        r.sangra = true; r.filete = filete; r.centro = [ccx, ccy];
      } else {
        var ins = iman2 ? Math.max(margenLogo, filete) : margenLogo + (rellena ? filete : 0);   // iman2: la imagen llega a la línea de seguridad (el borde blanco queda por fuera)
        var cw = r.cutW - 2 * ins, ch = r.cutH - 2 * ins;
        var k = Math.min(cw / px[0], ch / px[1]);
        if ((o.iman || o.libre) && o.zoom) k *= Math.max(0.4, Math.min(2.5, o.zoom));
        r.arteW = px[0] * k; r.arteH = px[1] * k;
        if (rellena) {
          r.relleno = colorIm || o.fondoColor; r.sangra = true; r.filete = filete; r.centro = [ccx, ccy];
        } else {
          r.borde = margenLogo;
          if (iman2 && filete) r.filete = filete;
        }
      }
    } else {
      /* TROQUELADA. El corte va por fuera del dibujo, así que el conjunto no
         puede pasarse del tamaño máximo del formato.
       *
       * Y CUANDO EL DIBUJO ESTÁ HECHO SOBRE UN FONDO DE COLOR, ese fondo es
       * parte del dibujo. Un escudo dorado diseñado sobre negro, cortado justo
       * donde acaba el oro, pierde el negro que le da el contraste y queda el
       * blanco del vinilo pegado a la tinta: postizo. Xavi, viendo cuatro
       * previas seguidas: «le falta negro a los 4».
       *
       * Así que entre la tinta y el blanco se deja un anillo DEL PROPIO FONDO
       * del archivo, del mismo grosor que el borde. Solo cuando el recorte
       * viene de una silueta sobre color (`o.silueta`); en un PNG recortado no
       * hay fondo que dejar. */
      /* Y solo cuando ese fondo es de COLOR. Si el diseño viene sobre blanco,
         el anillo sería blanco sobre blanco: no se vería y solo encogería el
         dibujo. */
      var aire = (o.silueta && o.fondoColor) ? borde : 0;
      var mw = formato.w - 2 * (borde + aire), mh = formato.h - 2 * (borde + aire);
      var k2 = Math.min(mw / px[0], mh / px[1]);
      r.arteW = px[0] * k2; r.arteH = px[1] * k2;
      r.aire = aire;
      r.cutW = r.arteW + 2 * (borde + aire); r.cutH = r.arteH + 2 * (borde + aire);

      /* EL BORDE TIENE UN SUELO FÍSICO (BORDE_MIN, la cuchilla), no cosmético:
         no se puede bajar más aunque se vea grueso. Así que cuando un diseño
         estrecho (un tirante, una silueta alargada) se pide en un tamaño
         pequeño, el borde mínimo de siempre se come un pellizco enorme del
         propio dibujo — Xavi, 28/09, viendo un delantal en 3 cm: «yo no lo
         veo proporcionado». No hay grosor que arreglarlo aquí: lo que hay que
         cambiar es el tamaño, así que se avisa de eso. */
      var estrecho = Math.min(r.arteW, r.arteH);
      if (estrecho > 0 && (borde + aire) / estrecho >= 0.15) {
        var mmBorde = Math.round((borde + aire) * 10) / 10;
        r.avisos.push({ tipo: 'borde-grande', texto: 'Tu diseño es estrecho y a este tamaño el borde blanco ' +
          '(' + String(mmBorde).replace('.', ',') + ' mm, el mínimo que admite la cuchilla) se come una parte ' +
          'grande del dibujo. Se ve mejor eligiendo un tamaño mayor.' });
      }
    }

    /* Cuánto del dibujo se queda fuera del corte. En el círculo se pierden
       siempre las cuatro esquinas (un 21 % aunque el archivo sea cuadrado), y
       ahí es justo donde la gente pone el año, la web o el nombre. */
    /* Con fondo de color no hay nada que perder: lo que llega al filo es el
       fondo y el dibujo va dentro completo, así que aquí no se avisa de un
       recorte que no existe. */
    if (r.sangra && !r.relleno) {
      var fw = r.cutW - 2 * (r.filete || 0), fh = r.cutH - 2 * (r.filete || 0);
      var visible = r.forma === 'redonda' ? Math.PI / 4 * fw * fh : fw * fh;
      r.recorte = Math.max(0, 1 - visible / (r.arteW * r.arteH));
      if (r.recorte >= 0.06) {
        /* EN CHAPAS EL RECORTE LO DECIDE EL ZOOM, NO EL FONDO. Aquí no hay
           vinilo ni «quitar el fondo» que valga —el cliente ya eligió que
           quepa entero por defecto y luego le dio al zoom él solo—, así que
           el arreglo que se le ofrece es bajar el propio zoom. */
        r.avisos.push({ tipo: 'recorte', texto: o.iman
          ? 'Se pierde alrededor del ' + Math.round(r.recorte * 100) + ' % de los bordes de tu diseño' +
            (r.forma === 'redonda' ? ', las esquinas seguro' : '') + '. Si prefieres que se vea entero, baja el ' +
            'tamaño de la imagen aquí debajo; y si quieres otra parte, arrástrala en la previa.'
          : o.chapa
          ? 'Con este zoom se pierde alrededor del ' + Math.round(r.recorte * 100) + ' % de los bordes de tu ' +
            'diseño, las esquinas seguro. Míralo en la previa: lo importante tiene que quedar en el centro. ' +
            'Si prefieres que se vea entero, baja el zoom.'
          : 'Para que ' + (o.iman ? (r.forma === 'redonda' ? 'el imán salga redondo entero' : 'el imán salga cuadrado entero') : (r.forma === 'redonda' ? 'la pegatina salga redonda entera' : 'la pegatina salga cuadrada entera')) +
            ', tu diseño llega hasta el filo y se pierde alrededor del ' + Math.round(r.recorte * 100) + ' % de los bordes' +
            (r.forma === 'redonda' ? ', las esquinas seguro' : '') + '. Míralo en la previa: lo importante ' +
            'tiene que quedar en el centro. Si prefieres que se vea entero, quítale el fondo aquí arriba y ' +
            'lo centramos con el blanco ' + (o.iman ? '' : 'del vinilo ') + 'alrededor.' });
      }
    }

    if (iman2 && o.zoom && o.zoom > 1.02) {
      r.avisos.push({ tipo: 'seguridad', texto: 'Con la imagen más grande que la zona de seguridad (la línea punteada), ' +
        'lo que quede fuera puede cortarse o quedar pegado al filo. Baja el tamaño si hay texto cerca del borde.' });
    }

    r.ppp = px[0] / (r.arteW / 25.4);
    if (r.ppp < (o.pppMin || 120)) {
      r.avisos.push({ tipo: 'resolucion', texto: 'A ese tamaño el archivo da ' +
        Math.round(r.ppp) + ' ppp. Para ' + (o.chapa ? 'la chapa' : (o.iman ? 'el imán' : 'pegatina')) +
        ' conviene 200 o más: por debajo se nota el pixelado de cerca.' });
    }
    /* Si el cliente ha elegido un vinilo que no es blanco (o casi), un diseño
       blanco sobre blanco deja de ser un problema —al contrario, se ve mejor
       que sobre uno claro—, así que el aviso solo tiene sentido con el
       vinilo de fábrica o algo igual de claro. */
    var vinRgb = hexRgb(o.colorVinilo);
    var vinLuz = (0.2126 * vinRgb[0] + 0.7152 * vinRgb[1] + 0.0722 * vinRgb[2]) / 255;
    if (o.arte && vinLuz >= 0.85) {
      var blanco = casiTodoBlanco(o.arte);
      /* El corte está en el 40 % mirando archivos reales: un logo con relieve
         blanco anda por el 27 %, uno con filete blanco por el 79 % y uno
         pensado para ropa oscura llega al 100 %. */
      if (blanco >= 0.4) {
        r.avisos.push({ tipo: 'blanco', nivel: 'info',
          texto: 'Ojo a la vista previa: el ' + Math.round(blanco * 100) + ' % de tu diseño es blanco, ' +
            'y el vinilo también lo es, así que esa parte no se va a ver. Si tienes la versión en color, ' +
            'esa va mejor; y si lo quieres así, dínoslo en las notas y le ponemos un fondo.' });
      }
    }
    if (formato.forma === 'libre' && o.transparente === false && !o.silueta) {
      /* Se llega aquí cuando el recorte automático no ha podido separar el
         fondo (una foto a sangre), o cuando el cliente ha deshecho el recorte
         a propósito. En los dos casos lo que hay que decirle es lo mismo. */
      r.avisos.push({ tipo: 'fondo', texto: 'Este archivo lleva fondo, así que el troquel ' +
        'saldría rectangular alrededor de la imagen. Para que siga la silueta hay que quitárselo: ' +
        'prueba el botón de aquí arriba, mándanos un PNG recortado, o marca el repaso del diseñador ' +
        'y lo recortamos nosotros.' });
    }
    return r;
  }

  /* ---------- silueta de un archivo CON fondo ----------
   *
   * El caso: una portada, un escudo, un emblema. Viene sobre un rectángulo
   * negro (o rojo, o el que sea) y ese color está TAMBIÉN dentro del dibujo,
   * entre las letras y entre los adornos. Quitarle el fondo lo agujerea — se
   * probó y se descartó.
   *
   * Pero troquelar un cuadrado tampoco es lo que ha pedido: si quisiera un
   * cuadrado habría elegido la cuadrada. Lo que hace un rotulista es cortar
   * por FUERA del emblema e imprimir el fondo que quede dentro. Eso es esto:
   *
   *   1. Marca lo que NO es el color del borde.
   *   2. CIERRE: engorda y vuelve a adelgazar. Así los trozos sueltos —los
   *      arcos partidos, las alas, las letras— se unen en una sola mancha,
   *      que es como lo ve un ojo a un metro.
   *   3. Rellena los huecos que hayan quedado dentro.
   *
   * Lo que se imprime sigue siendo el archivo entero, fondo incluido. Lo único
   * que cambia es por dónde pasa la cuchilla.
   */
  function colorMarco(d, w, h) {
    var p = d, cubos = {}, total = 0;
    function mete(i) {
      if (p[i + 3] < 8) return;
      var k = (p[i] >> 4) + ',' + (p[i + 1] >> 4) + ',' + (p[i + 2] >> 4);
      var c = cubos[k] || (cubos[k] = { n: 0, r: 0, g: 0, b: 0 });
      c.n++; c.r += p[i]; c.g += p[i + 1]; c.b += p[i + 2]; total++;
    }
    for (var x = 0; x < w; x++) { mete(x * 4); mete(((h - 1) * w + x) * 4); }
    for (var y = 0; y < h; y++) { mete((y * w) * 4); mete((y * w + w - 1) * 4); }
    var mejor = null;
    Object.keys(cubos).forEach(function (k) { if (!mejor || cubos[k].n > mejor.n) mejor = cubos[k]; });
    if (!mejor) return null;
    return { r: mejor.r / mejor.n, g: mejor.g / mejor.n, b: mejor.b / mejor.n, parte: mejor.n / Math.max(1, total) };
  }

  /* CUÁNTO SE PUEDE APARTAR DEL COLOR DEL MARCO Y SEGUIR SIENDO MARCO.
   *
   * Estaba clavado en 70, y 70 es muchísimo. El emblema de una churrería que
   * mandó un cliente lleva un aro exterior color crema; del blanco del fondo se
   * aparta 62. O sea que ese aro entraba en el saco del fondo: la cuchilla se
   * metía por dentro del dibujo, se comía el aro a trozos —los que el JPG dejaba
   * un pelo más oscuros— y la pegatina salía con bollos y con un mordisco
   * abajo a la izquierda, donde el churro cruza el aro con un brillo claro.
   *
   * El margen no lo ponemos nosotros: lo pone el archivo. Se mide cuánto varía
   * el color en el propio marco —eso es el ruido del JPG, y en un fondo blanco
   * limpio son tres unidades— y se da por fondo lo que no se aparte mucho más
   * que eso. Con un fondo sucio o con degradado, el ruido sube y el margen sube
   * con él. Se usa el percentil 90 y no el máximo porque si el dibujo toca el
   * borde del archivo, ese trozo de dibujo también está en la muestra. */
  function tolDeMarco(d, w, h, fondo) {
    var ds = [];
    function mete(i) {
      if (d[i + 3] < 8) return;
      var dr = d[i] - fondo.r, dg = d[i + 1] - fondo.g, db = d[i + 2] - fondo.b;
      ds.push(Math.sqrt(dr * dr + dg * dg + db * db));
    }
    for (var x = 0; x < w; x++) { mete(x * 4); mete(((h - 1) * w + x) * 4); }
    for (var y = 0; y < h; y++) { mete((y * w) * 4); mete((y * w + w - 1) * 4); }
    if (ds.length < 8) return 70;
    ds.sort(function (a, b) { return a - b; });
    var p90 = ds[Math.floor(ds.length * 0.9)];
    return Math.max(12, Math.min(70, p90 * 3));
  }

  /* Distancia al 1 más cercano, EUCLÍDEA DE VERDAD.
   *
   * Antes esto era un chamfer (sumar 1 en recto y 1,41 en diagonal). Es rápido,
   * pero su "círculo" es un octógono: al separarse siempre la misma distancia
   * del dibujo, el contorno salía con tramos rectos en horizontal, vertical y a
   * 45°. Se veía sobre todo en pegatinas pequeñas.
   *
   * Esta versión hace la distancia exacta con el método de las parábolas
   * (Felzenszwalb–Huttenlocher): una pasada por columnas y otra por filas, cada
   * una quedándose con la envolvente inferior. Sigue siendo O(n) y ahora el
   * círculo es un círculo, así que el corte sale redondeado en todas las
   * direcciones por igual. */
  function env1d(f, d, v, z, n) {
    var k = 0, q, s;
    v[0] = 0; z[0] = -1e20; z[1] = 1e20;
    for (q = 1; q < n; q++) {
      s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
      while (s <= z[k]) {
        k--;
        s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
      }
      k++; v[k] = q; z[k] = s; z[k + 1] = 1e20;
    }
    k = 0;
    for (q = 0; q < n; q++) {
      while (z[k + 1] < q) k++;
      d[q] = (q - v[k]) * (q - v[k]) + f[v[k]];
    }
  }

  function distancia(m, w, h) {
    var INF = 1e20, n = w * h, i, x, y;
    var D = new Float64Array(n);
    for (i = 0; i < n; i++) D[i] = m[i] ? 0 : INF;
    var lado = Math.max(w, h);
    var f = new Float64Array(lado), d = new Float64Array(lado);
    var v = new Int32Array(lado), z = new Float64Array(lado + 1);
    for (x = 0; x < w; x++) {
      for (y = 0; y < h; y++) f[y] = D[y * w + x];
      env1d(f, d, v, z, h);
      for (y = 0; y < h; y++) D[y * w + x] = d[y];
    }
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) f[x] = D[y * w + x];
      env1d(f, d, v, z, w);
      for (x = 0; x < w; x++) D[y * w + x] = Math.sqrt(d[x]);
    }
    return D;
  }

  /* Cierre morfológico: engorda r y vuelve a adelgazar r. Se come los dientes
     y los huecos más pequeños que r y deja el resto igual. */
  function cerrar(m, w, h, r) {
    var n = w * h, i;
    var D = distancia(m, w, h);
    var dil = new Uint8Array(n);
    for (i = 0; i < n; i++) if (D[i] <= r) dil[i] = 1;
    var fuera = new Uint8Array(n);
    for (i = 0; i < n; i++) fuera[i] = dil[i] ? 0 : 1;
    var D2 = distancia(fuera, w, h);
    var out = new Uint8Array(n);
    for (i = 0; i < n; i++) if (D2[i] > r) out[i] = 1;
    return out;
  }

  /* HUECOS DE DENTRO: lo que no se alcanza desde fuera es del dibujo. Se corta
     por fuera y nada más (Xavi, 01/10: «que no recorte interiores»): las
     letras con ojo, los anillos y los huecos entre piezas quedan dentro del
     imán, igual que hace el panel al montar el corte (_tapar_agujeros). */
  function rellenarHuecos(m, w, h) {
    var n = w * h, fuera = new Uint8Array(n), pila = new Int32Array(n), t = 0, i, x, y;
    function semilla(k) { if (!m[k] && !fuera[k]) { fuera[k] = 1; pila[t++] = k; } }
    for (x = 0; x < w; x++) { semilla(x); semilla((h - 1) * w + x); }
    for (y = 0; y < h; y++) { semilla(y * w); semilla(y * w + w - 1); }
    while (t) {
      var k = pila[--t], kx = k % w, ky = (k - kx) / w;
      if (kx > 0) semilla(k - 1);
      if (kx < w - 1) semilla(k + 1);
      if (ky > 0) semilla(k - w);
      if (ky < h - 1) semilla(k + w);
    }
    var out = new Uint8Array(n);
    for (i = 0; i < n; i++) out[i] = fuera[i] ? 0 : 1;
    return out;
  }

  /* Quita las islas sueltas: se queda con las piezas de al menos `fr` veces la mayor. Un imán es UNA pieza: los trocitos que deja
     «quitar fondo» (mechones, puntos) se caerían al cortar. */
  function quitarIslas(m, w, h, fr) {
    var n = w * h, etq = new Int32Array(n), areas = [0], cola = new Int32Array(n), c = 0, i, a, b, v, x, y;
    for (i = 0; i < n; i++) {
      if (!m[i] || etq[i]) continue;
      c++; a = 0; b = 0; cola[b++] = i; etq[i] = c;
      while (a < b) {
        v = cola[a++]; x = v % w; y = (v - x) / w;
        if (x > 0 && m[v - 1] && !etq[v - 1]) { etq[v - 1] = c; cola[b++] = v - 1; }
        if (x < w - 1 && m[v + 1] && !etq[v + 1]) { etq[v + 1] = c; cola[b++] = v + 1; }
        if (y > 0 && m[v - w] && !etq[v - w]) { etq[v - w] = c; cola[b++] = v - w; }
        if (y < h - 1 && m[v + w] && !etq[v + w]) { etq[v + w] = c; cola[b++] = v + w; }
      }
      areas.push(b);
    }
    var mayor = Math.max.apply(null, areas), out = new Uint8Array(n);
    for (i = 0; i < n; i++) if (etq[i] && areas[etq[i]] >= mayor * fr) out[i] = 1;
    return out;
  }

  /* Apertura: adelgaza r y vuelve a engordar r. Es el cierre del revés y hace
     lo contrario: redondea los SALIENTES en vez de los entrantes, y se come los
     pinchos más finos que r. Es lo que le falta al margen negro de dentro. */
  function abrir(m, w, h, r) {
    var n = w * h, i;
    var fuera = new Uint8Array(n);
    for (i = 0; i < n; i++) fuera[i] = m[i] ? 0 : 1;
    var D = distancia(fuera, w, h);          // cuánto se mete cada punto
    var ero = new Uint8Array(n);
    for (i = 0; i < n; i++) if (D[i] > r) ero[i] = 1;
    var D2 = distancia(ero, w, h);
    var out = new Uint8Array(n);
    for (i = 0; i < n; i++) if (D2[i] <= r) out[i] = 1;
    return out;
  }

  function luzDe(c) { return (0.299 * c.r + 0.587 * c.g + 0.114 * c.b) / 255; }

  /* SOMBRAS (Xavi, 14/10: «eliminar sombras del diseño antes de nada»). Una sombra paralela hace crecer el troquel con una zona difuminada que no es del dibujo.
   * Con transparencia: lo semitransparente, gris/oscuro y a más de `r` px del dibujo sólido (alfa ≥ 245) es sombra.
   * Con fondo liso: desde el fondo se avanza por el gris neutro que oscurece poco a poco (pasos ≤ 6, luminancia ≥ 80); el dibujo empieza donde hay un salto.
   * Conservador a propósito: lo que tenga color (un cristal, un degradado de color) no se toca. Se quita con opciones.sinSombra === false. */
  function quitarSombraAlfa(m, d, w, h, r, fuera) {
    var n = w * h, nuc = new Uint8Array(n), tmp = new Uint8Array(n), cerca = new Uint8Array(n), i, x, y, k;
    for (i = 0; i < n; i++) nuc[i] = d[i * 4 + 3] >= 245 ? 1 : 0;
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) { var a = 0; for (k = -r; k <= r && !a; k++) { var xq = x + k; if (xq >= 0 && xq < w && nuc[y * w + xq]) a = 1; } tmp[y * w + x] = a; }
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) { var b = 0; for (k = -r; k <= r && !b; k++) { var yq = y + k; if (yq >= 0 && yq < h && tmp[yq * w + x]) b = 1; } cerca[y * w + x] = b; }
    var quitados = 0;
    for (i = 0; i < n; i++) {
      if (!m[i] || cerca[i] || d[i * 4 + 3] >= 245) continue;
      var o = i * 4, mx = Math.max(d[o], d[o + 1], d[o + 2]), mn = Math.min(d[o], d[o + 1], d[o + 2]), lum = 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2];
      if (mx - mn < 28 && lum < 150) { m[i] = 0; quitados++; if (fuera) fuera[i] = 1; }
    }
    return quitados;
  }
  function quitarSombraGradiente(m, d, w, h) {
    var n = w * h, vis = new Uint8Array(n), pila = new Int32Array(n), sp = 0, i, quitados = 0;
    function lum(k) { var o = k * 4; return 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2]; }
    function neutro(k) { var o = k * 4, mx = Math.max(d[o], d[o + 1], d[o + 2]), mn = Math.min(d[o], d[o + 1], d[o + 2]); return mx - mn < 28; }
    for (i = 0; i < n; i++) if (!m[i] && d[i * 4 + 3] >= 128) { var xi = i % w, yi = (i / w) | 0; if ((xi > 0 && m[i - 1]) || (xi < w - 1 && m[i + 1]) || (yi > 0 && m[i - w]) || (yi < h - 1 && m[i + w])) pila[sp++] = i; }
    function prueba(desde, k) {
      if (!m[k] || vis[k] || !neutro(k)) return;
      var l0 = lum(desde), l1 = lum(k);
      if (l1 >= 80 && Math.abs(l1 - l0) <= 6 && l1 <= l0 + 3) { vis[k] = 1; m[k] = 0; quitados++; pila[sp++] = k; }
    }
    while (sp) {
      var k2 = pila[--sp], x = k2 % w, y = (k2 / w) | 0;
      if (x > 0) prueba(k2, k2 - 1); if (x < w - 1) prueba(k2, k2 + 1); if (y > 0) prueba(k2, k2 - w); if (y < h - 1) prueba(k2, k2 + w);
      if (sp > n - 8) break;
    }
    return quitados;
  }

  function silueta(arte, opciones) {
    var o = opciones || {};
    var w = arte.width, h = arte.height, n = w * h;
    var ctx = arte.getContext('2d', { willReadFrequently: true });
    var d = ctx.getImageData(0, 0, w, h).data;
    var fondo = colorMarco(d, w, h);
    if (!fondo || fondo.parte < 0.5) return null;   // el marco no es de un color: es una foto

    var tol = o.tolerancia == null ? tolDeMarco(d, w, h, fondo) : o.tolerancia;
    var m = new Uint8Array(n), hay = 0;
    for (var i = 0; i < n; i++) {
      if (d[i * 4 + 3] < 128) continue;
      var dr = d[i * 4] - fondo.r, dg = d[i * 4 + 1] - fondo.g, db = d[i * 4 + 2] - fondo.b;
      if (Math.sqrt(dr * dr + dg * dg + db * db) > tol) { m[i] = 1; hay++; }
    }
    if (o.sinSombra !== false) { var qs = quitarSombraGradiente(m, d, w, h); if (qs) { hay = 0; for (var iq = 0; iq < n; iq++) if (m[iq]) hay++; } }
    if (!hay) return null;

    /* EL CORTE SIGUE LA TINTA, Y EL MARGEN LO PONE EL MARGEN.
     *
     * Aquí había dos engordes encima del dibujo —un cierre del 4 % del lado
     * mayor y un «aire» del 3 %— y luego, al dibujar, todavía se separaba el
     * borde blanco. Tres capas de grasa sobre la misma silueta: un emblema
     * redondo salía con forma de patata, con rectas y mordiscos donde el
     * engorde de dos salientes vecinos se juntaba. Se veía en el logo de una
     * churrería que mandó un cliente y no había manera de defenderlo.
     *
     * Lo que se hace ahora es lo que haría cualquiera con el plóter delante:
     * se corta por donde hay tinta y se separa el borde de una vez, en
     * milímetros, en el momento de calcular el corte. Aquí solo queda soldar
     * lo que está partido —las letras sueltas, los arcos de un aro— para que
     * la pegatina salga de una pieza, y para eso basta un cierre pequeño: lo
     * que quede a menos de eso ya lo une después el propio borde. */
    var rad = Math.max(2, (o.cierre == null ? 0.015 : o.cierre) * Math.max(w, h));
    var aire = (o.aire == null ? 0 : o.aire) * Math.max(w, h);

    /* TODA LA MORFOLOGÍA SE HACE CON MARGEN ALREDEDOR.
     *
     * Engordar y adelgazar contra el filo del lienzo es la trampa clásica: el
     * engorde se sale, el lienzo lo corta, y al adelgazar después la forma
     * vuelve MENOS de lo que salió y queda un lado RECTO. Con un sello redondo
     * que toca los cuatro lados de su PNG —que es de lo más corriente— la
     * pegatina salía con forma de polígono: un lado plano arriba, otro abajo y
     * otro a cada costado.
     *
     * Así que se trabaja en un lienzo más grande, con sitio de sobra para el
     * cierre y para el aire, y al final se recorta a lo que mide el archivo:
     * donde no hay archivo no hay nada que imprimir, pero la curva llega al
     * filo con su forma de verdad en vez de con el corte del lienzo. */
    var p = Math.ceil(rad + aire + 4);
    var W2 = w + 2 * p, H2 = h + 2 * p, n2 = W2 * H2;
    var idx = function (x, y) { return (y + p) * W2 + (x + p); };
    var mp = new Uint8Array(n2);
    for (var y0 = 0; y0 < h; y0++) {
      for (var x0 = 0; x0 < w; x0++) if (m[y0 * w + x0]) mp[idx(x0, y0)] = 1;
    }

    var cerr = cerrar(mp, W2, H2, rad);

    if (aire >= 1) {
      var D3 = distancia(cerr, W2, H2);
      var conAire = new Uint8Array(n2);
      for (i = 0; i < n2; i++) if (D3[i] <= aire) conAire[i] = 1;
      /* Y SE VUELVE A CERRAR. Engordar el dibujo redondea los salientes pero
         deja los ENTRANTES en pico —el hueco entre un ala y el aro sale en uve—,
         que es justo lo que se ve mal en el margen negro. Un cierre después del
         aire le pasa la bola por dentro y esos rincones salen redondeados. */
      cerr = cerrar(conAire, W2, H2, rad);
    }

    // rellenar huecos: lo que no se alcanza desde el borde es de dentro
    var visto = new Uint8Array(n2), pila = new Int32Array(n2), tope = 0;
    function empuja(k) { if (!visto[k] && !cerr[k]) { visto[k] = 1; pila[tope++] = k; } }
    for (var x3 = 0; x3 < W2; x3++) { empuja(x3); empuja((H2 - 1) * W2 + x3); }
    for (var y3 = 0; y3 < H2; y3++) { empuja(y3 * W2); empuja(y3 * W2 + W2 - 1); }
    while (tope > 0) {
      var k = pila[--tope], kx = k % W2, ky = (k - kx) / W2;
      if (kx > 0) empuja(k - 1);
      if (kx < W2 - 1) empuja(k + 1);
      if (ky > 0) empuja(k - W2);
      if (ky < H2 - 1) empuja(k + W2);
    }

    var minX = w, minY = h, maxX = -1, maxY = -1, dentro = 0;
    var out = ctx.createImageData(w, h), q = out.data;
    for (var y4 = 0; y4 < h; y4++) {
      for (var x4 = 0; x4 < w; x4++) {
        var j = y4 * w + x4, jp = idx(x4, y4);
        if (cerr[jp] || !visto[jp]) {
          q[j * 4] = q[j * 4 + 1] = q[j * 4 + 2] = 255; q[j * 4 + 3] = 255;
          dentro++;
          if (x4 < minX) minX = x4; if (x4 > maxX) maxX = x4;
          if (y4 < minY) minY = y4; if (y4 > maxY) maxY = y4;
        }
      }
    }
    if (maxX < 0) return null;
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    c.getContext('2d').putImageData(out, 0, 0);
    var bw = maxX - minX + 1, bh = maxY - minY + 1;
    return {
      lienzo: c, x: minX, y: minY, w: bw, h: bh,
      // el color que el diseñador puso detrás, para poder estirarlo al cortar
      fondo: 'rgb(' + Math.round(fondo.r) + ',' + Math.round(fondo.g) + ',' + Math.round(fondo.b) + ')',
      fondoClaro: luzDe(fondo) > 0.88,
      // si la silueta es el rectángulo entero, no hemos recortado nada
      lleno: dentro / (bw * bh) > 0.97 && (bw * bh) / n > 0.97
    };
  }

  /* HASTA DÓNDE LLEGA LA TINTA, medido desde el centro del archivo y en tanto
     por uno de la media diagonal.

     Un diseño que llena el rectángulo hasta las esquinas da 1. Uno redondo da
     0,71 (la mitad del lado partido por la mitad de la diagonal). Es lo que
     hace falta para meter un dibujo dentro de un círculo sin dejarse medio
     centímetro de blanco por el camino. Se mide sobre una copia pequeña: con
     120 píxeles de ancho sobra para saber dónde acaba la tinta. */
  function radioMax(lienzo) {
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.min(120, lienzo.width));
    c.height = Math.max(1, Math.round(lienzo.height * c.width / lienzo.width));
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(lienzo, 0, 0, c.width, c.height);
    var d = x.getImageData(0, 0, c.width, c.height).data;
    var cx = c.width / 2, cy = c.height / 2;
    var media = Math.sqrt(cx * cx + cy * cy);
    var max = 0;
    for (var y = 0; y < c.height; y++) {
      for (var i = 0; i < c.width; i++) {
        if (d[(y * c.width + i) * 4 + 3] < 128) continue;
        var dx = i + 0.5 - cx, dy = y + 0.5 - cy;
        var r = Math.sqrt(dx * dx + dy * dy);
        if (r > max) max = r;
      }
    }
    // suelo por si el archivo viene casi vacío: nunca agrandar más del doble
    return Math.min(1, Math.max(0.5, max / media));
  }

  /* ¿El dibujo es casi todo blanco? El vinilo es blanco, así que un diseño
     blanco sobre blanco no se ve. Pasa con los logos pensados para prenda
     oscura, que es justo lo que suele tener a mano un cliente. */
  function casiTodoBlanco(lienzo) {
    var n = 120;
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.min(n, lienzo.width));
    c.height = Math.max(1, Math.round(lienzo.height * c.width / lienzo.width));
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(lienzo, 0, 0, c.width, c.height);
    var d = x.getImageData(0, 0, c.width, c.height).data;
    var tinta = 0, blancos = 0;
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 128) continue;
      tinta++;
      if (d[i] > 232 && d[i + 1] > 232 && d[i + 2] > 232) blancos++;
    }
    return tinta ? blancos / tinta : 0;
  }

  // '#rrggbb' -> [r,g,b]; sin color o mal escrito, blanco (el vinilo de fábrica)
  function hexRgb(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    return (h.length === 6 && !isNaN(n)) ? [(n >> 16) & 255, (n >> 8) & 255, n & 255] : [255, 255, 255];
  }

  function dibujar(lienzo, arte, p, opciones) {
    var o = opciones || {};
    var anchoCss = o.ancho || 320;
    /* Con cotas hace falta un poco más de aire: la flecha y su número viven
       en ese margen. Antes eran 17 mm fijos, y en una pegatina pequeña (3 cm)
       ese margen mide casi lo mismo que la propia pegatina: la previa se veía
       diminuta en medio de un cuadro de aire — Xavi, 28/09: «como salen las
       medidas no hace falta que se vea pequeña, que aproveche la pantalla».
       Las flechas y el texto se dibujan siempre al mismo tamaño EN PANTALLA
       (más abajo, en unidades `u = 1/escala`), así que lo que hace falta es
       un margen que ocupe siempre esos mismos píxeles de pantalla, sea cual
       sea el tamaño real de la pegatina — no un margen fijo en milímetros.
       Se despeja de escala = ancho/(cutW+2·margen) para que margen·escala
       dé ese hueco fijo. */
    var margen = (opciones && opciones.cotas)
      ? Math.max(4, (48 * p.cutW) / Math.max(1, anchoCss - 96))
      : 14;   // mm de aire alrededor
    var totalW = p.cutW + margen * 2, totalH = p.cutH + margen * 2;
    var escala = anchoCss / totalW;                   // px por mm
    var dpr = window.devicePixelRatio || 1;
    /* El ancho va en píxeles porque hay que dibujar a escala de verdad, pero
       NUNCA por encima de lo que hay: el max-width lo encoge en el móvil y la
       altura la saca el navegador de la proporción del propio canvas. Si se
       deja la altura clavada, al encogerse se deforma. */
    lienzo.style.width = Math.round(anchoCss) + 'px';
    lienzo.style.maxWidth = '100%';
    lienzo.style.height = 'auto';
    lienzo.width = Math.round(anchoCss * dpr);
    lienzo.height = Math.round(totalH * escala * dpr);
    var c = lienzo.getContext('2d');
    c.setTransform(dpr * escala, 0, 0, dpr * escala, 0, 0);   // ahora se trabaja en mm
    c.clearRect(0, 0, totalW, totalH);

    var cx = margen + p.cutW / 2, cy = margen + p.cutH / 2;
    // el dibujo se coloca por SU centro, que no tiene por qué ser el del archivo
    // (más el desplazamiento a mano del cliente, si lo ha arrastrado — chapas)
    var ax = cx - p.arteW * (p.centro ? p.centro[0] : 0.5) + (p.offX || 0);
    var ay = cy - p.arteH * (p.centro ? p.centro[1] : 0.5) + (p.offY || 0);
    var corte = '#c81e5a';                            // rosa: la línea de corte

    if (p.forma === 'libre') {
      /* EL CORTE SE CALCULA, NO SE PINTA A OJO.
       *
       * Antes el contorno salía de estampar el dibujo muchas veces en círculo.
       * Con 3 mm colaba, pero con 1,5 el corte se metía en cada diente del
       * pincel y salía una línea temblorosa — y además eso el plóter no lo
       * corta: la cuchilla tiene su radio y redondea igual.
       *
       * Ahora se hace con un campo de distancia:
       *   1. la silueta en píxeles,
       *   2. un cierre de 1 mm que se come los dientes y los huecos pequeños,
       *   3. la distancia a esa silueta, y el filo donde la distancia vale
       *      exactamente el borde.
       * La línea sale lisa y con el mismo criterio en toda la pegatina. */
      var mask = o.mascara || arte;
      var W = lienzo.width, H = lienzo.height, ppm = dpr * escala;   // píxeles por mm
      var tmp = document.createElement('canvas');
      tmp.width = W; tmp.height = H;
      var t = tmp.getContext('2d', { willReadFrequently: true });
      t.setTransform(ppm, 0, 0, ppm, 0, 0);
      t.drawImage(mask, ax, ay, p.arteW, p.arteH);

      var dm = t.getImageData(0, 0, W, H).data;
      var n2 = W * H, m2 = new Uint8Array(n2), i2;
      for (i2 = 0; i2 < n2; i2++) m2[i2] = dm[i2 * 4 + 3] >= 96 ? 1 : 0;
      var sombraFuera = new Uint8Array(n2);
      if (o.sinSombra !== false) quitarSombraAlfa(m2, dm, W, H, Math.max(1, Math.round(0.1 * ppm)), sombraFuera);   // el troquel no sigue sombras difuminadas (y el dibujo tampoco las imprime)
      m2 = cerrar(m2, W, H, Math.max(1, ppm));        // 1 mm de cierre
      /* IMANES: UNA SOLA PIEZA, DE FORMA SENCILLA (Xavi, 14/10: «fallo en los imanes, imagen quitando el fondo»). Quitar el fondo de un
         dibujo oscuro deja el pelo, la barba… como huecos y mechones sueltos, y el corte seguía cada uno: una línea rota y llena de
         islas que se caerían al cortar. Para un imán se cierra con un radio grande (una décima parte del lado corto), se tiran las
         islas pequeñas y se rellenan los huecos: queda el contorno de la figura, liso y de una pieza. */
      if (o.iman) {
        var rIman = Math.max(ppm, 0.1 * Math.min(p.cutW, p.cutH) * ppm);
        m2 = cerrar(m2, W, H, rIman);
        m2 = quitarIslas(m2, W, H, 0.03);
      }
      m2 = rellenarHuecos(m2, W, H);                  // sin cortes por dentro
      var Dc = distancia(m2, W, H);

      /* LA PEGATINA es todo lo que queda a menos de un borde de la tinta…
         …pero separarse una distancia fija redondea los SALIENTES y deja los
         ENTRANTES en pico: en el hueco entre un ala y el aro, las dos curvas se
         cruzan en uve y el plóter no corta eso. Un cierre del tamaño del propio
         borde pasa la bola por dentro del contorno y esos rincones salen
         redondeados, que es como se corta de verdad. */
      var rB = p.borde * ppm, rA = (p.aire || 0) * ppm;
      var dentro = new Uint8Array(n2);
      /* rA es el anillo del propio fondo del archivo (ver `plan`); rB es el
         blanco del vinilo. La pegatina es la suma de los dos. */
      for (i2 = 0; i2 < n2; i2++) dentro[i2] = Dc[i2] <= rB + rA ? 1 : 0;
      dentro = cerrar(dentro, W, H, rB + rA);
      dentro = rellenarHuecos(dentro, W, H);          // sin agujeros en la pegatina (Xavi, 14/10: logo sin fondo «agujereado»): un entrante hondo con la boca estrecha, como el de una C junto a una S, no se corta por dentro

      // distancia al filo de esa forma, contada por los dos lados
      var fuera2 = new Uint8Array(n2);
      for (i2 = 0; i2 < n2; i2++) fuera2[i2] = dentro[i2] ? 0 : 1;
      var Dfuera = distancia(dentro, W, H);     // 0 dentro, crece hacia afuera
      var Ddentro = distancia(fuera2, W, H);    // 0 fuera, crece hacia adentro

      var out = c.createImageData(W, H), q = out.data;
      /* El GROSOR de la línea va en píxeles de pantalla, no en milímetros. En
         milímetros la misma línea se ve fina en una pegatina de 10 cm y como
         un rotulador en una de 3, porque la previa siempre ocupa el mismo
         ancho: lo que cambia es la escala. Un píxel y pico a cada lado se ve
         igual de fino en todos los tamaños. */
      var medio = 1 * dpr;
      // el vinilo, blanco de fábrica o del color que haya elegido el cliente (se imprime)
      var vRgb = hexRgb(o.colorVinilo);
      for (i2 = 0; i2 < n2; i2++) {
        var dd = Dfuera[i2] + Ddentro[i2];      // distancia al filo
        // rosa: la propia línea de corte. vinilo: el relleno de dentro.
        var aRosa = Math.max(0, Math.min(1, (medio - dd) + 0.5));
        var aBlanco = dentro[i2] ? Math.max(0, Math.min(1, (dd - medio) + 0.5)) : 0;
        if (aRosa > 0) {
          q[i2 * 4] = 200; q[i2 * 4 + 1] = 30; q[i2 * 4 + 2] = 90;
          q[i2 * 4 + 3] = Math.round(255 * aRosa);
        } else if (aBlanco > 0) {
          q[i2 * 4] = vRgb[0]; q[i2 * 4 + 1] = vRgb[1]; q[i2 * 4 + 2] = vRgb[2];
          q[i2 * 4 + 3] = Math.round(255 * aBlanco);
        }
      }
      c.setTransform(1, 0, 0, 1, 0, 0);
      c.putImageData(out, 0, 0);
      c.setTransform(ppm, 0, 0, ppm, 0, 0);

      if (o.mascara) {
        /* EL FILO DEL NEGRO ES LA LÍNEA DE CORTE MOVIDA HACIA DENTRO, Y YA.
         *
         * Xavi, mirando una previa ampliada: *«si la línea roja está perfecta
         * porque el reborde negro no es igual?»*. Porque aquí, después de
         * encoger, se le pasaba una APERTURA que redondeaba los salientes con
         * su propio radio y dejaba el negro con un filo distinto del corte: en
         * unos sitios más gordo, en otros comido.
         *
         * Aquella apertura tenía sentido cuando la pegatina era el dibujo
         * engordado justo el borde: al volver hacia dentro, las esquinas
         * redondeadas se cerraban en PUNTA. Ya no: ahora la pegatina se engorda
         * el anillo del fondo MÁS el borde y se cierra con ese radio, así que
         * al encoger solo el borde los rincones siguen teniendo curva de sobra.
         *
         * Sin la apertura, el blanco mide lo mismo en toda la vuelta y las dos
         * líneas van paralelas, que es lo que se ve bien. */
        var interior = new Uint8Array(n2);
        for (i2 = 0; i2 < n2; i2++) interior[i2] = Ddentro[i2] > rB ? 1 : 0;
        if (!rA) interior = abrir(interior, W, H, rB);
        var fuera3 = new Uint8Array(n2);
        for (i2 = 0; i2 < n2; i2++) fuera3[i2] = interior[i2] ? 0 : 1;
        var Dint = distancia(fuera3, W, H);     // 0 fuera, crece hacia dentro

        var mk = c.createImageData(W, H), mq = mk.data;
        for (i2 = 0; i2 < n2; i2++) {
          var am = Math.max(0, Math.min(1, Dint[i2] - 0.5));
          if (am > 0) {
            mq[i2 * 4] = mq[i2 * 4 + 1] = mq[i2 * 4 + 2] = 255;
            mq[i2 * 4 + 3] = Math.round(255 * am);
          }
        }
        t.setTransform(1, 0, 0, 1, 0, 0); t.clearRect(0, 0, W, H);
        t.globalCompositeOperation = 'source-over';
        t.putImageData(mk, 0, 0);
        t.globalCompositeOperation = 'source-in';
        /* EL ANILLO SE PINTA, NO SE COPIA.
           Estirar el archivo no sirve: donde el dibujo llega al filo de su
           propio PNG no hay fondo que estirar, y el anillo salía a trozos
           —justo donde las alas tocan el borde—. Se rellena del color que se
           midió en el marco del archivo y encima se dibuja el arte: el anillo
           queda entero y del color que el diseñador puso detrás. */
        if (o.fondoColor) {
          t.setTransform(1, 0, 0, 1, 0, 0);
          t.fillStyle = o.fondoColor;
          t.fillRect(0, 0, W, H);
          t.globalCompositeOperation = 'source-atop';
        }
        t.setTransform(ppm, 0, 0, ppm, 0, 0);
        t.drawImage(arte, ax, ay, p.arteW, p.arteH);
        t.globalCompositeOperation = 'source-over';
        c.setTransform(1, 0, 0, 1, 0, 0);
        c.drawImage(tmp, 0, 0);
        c.setTransform(ppm, 0, 0, ppm, 0, 0);
      } else if (o.sinSombra !== false) {
        /* Sin silueta aparte (PNG recortado): el dibujo va RECORTADO por el propio troquel, como en la pegatina de verdad. Así una sombra difuminada
           que queda fuera del corte no se enseña (y no se imprime) dentro de la previa. */
        var cvA = document.createElement('canvas'); cvA.width = W; cvA.height = H;
        var ta = cvA.getContext('2d');
        ta.setTransform(ppm, 0, 0, ppm, 0, 0);
        ta.drawImage(arte, ax, ay, p.arteW, p.arteH);
        var imA = ta.getImageData(0, 0, W, H), dA = imA.data;      // la sombra tampoco se imprime dentro del borde blanco
        for (i2 = 0; i2 < n2; i2++) if (sombraFuera[i2]) dA[i2 * 4 + 3] = 0;
        ta.putImageData(imA, 0, 0);
        var cvM = document.createElement('canvas'); cvM.width = W; cvM.height = H;
        var tm = cvM.getContext('2d'), mkA = tm.createImageData(W, H), mqA = mkA.data;
        for (i2 = 0; i2 < n2; i2++) {
          if (!dentro[i2]) continue;
          var aq = Math.max(0, Math.min(1, Ddentro[i2] + 0.5));
          mqA[i2 * 4] = mqA[i2 * 4 + 1] = mqA[i2 * 4 + 2] = 255; mqA[i2 * 4 + 3] = Math.round(255 * aq);
        }
        tm.putImageData(mkA, 0, 0);
        ta.setTransform(1, 0, 0, 1, 0, 0);
        ta.globalCompositeOperation = 'destination-in';
        ta.drawImage(cvM, 0, 0);
        c.setTransform(1, 0, 0, 1, 0, 0);
        c.drawImage(cvA, 0, 0);
        c.setTransform(ppm, 0, 0, ppm, 0, 0);
      } else {
        c.drawImage(arte, ax, ay, p.arteW, p.arteH);
      }
    } else {
      // el vinilo primero, blanco de fábrica o del color que haya elegido el cliente
      c.fillStyle = o.colorVinilo || '#ffffff';
      trazar(c, p, margen);
      if (o.sombra) {
        // una sombra suave bajo la pieza, para que parezca un objeto y no un dibujo plano
        c.save();
        c.shadowColor = 'rgba(0,0,0,.30)'; c.shadowBlur = 10 * dpr; c.shadowOffsetY = 2.5 * dpr;
        c.fill();
        c.restore();
      }
      c.fill();

      /* El dibujo va RECORTADO por la propia línea de corte. Cuando va a
         sangre se sale de la forma, y enseñarlo entero sería enseñar una
         pegatina que no existe: lo que se lleva el cliente es lo de dentro. */
      c.save();
      if (p.filete) {
        // esquina concéntrica con la de fuera: el borde blanco mide lo mismo en toda la vuelta
        trazar(c, { forma: p.forma, cutW: p.cutW - 2 * p.filete, cutH: p.cutH - 2 * p.filete,
          radio: Math.max(0.6, Math.min(3, p.cutW / 4, p.cutH / 4) - p.filete) }, margen + p.filete);
      } else {
        trazar(c, p, margen);
      }
      c.clip();
      /* EL FONDO DEL PROPIO DISEÑO, ESTIRADO HASTA EL FILO. Así la pegatina
         sale llena de tinta sin agrandar el dibujo hasta cortarlo (ver `plan`).
         Va debajo, y el dibujo entero encima. */
      if (p.relleno) {
        c.fillStyle = p.relleno;
        c.fillRect(0, 0, totalW, totalH);
      }
      c.drawImage(arte, ax, ay, p.arteW, p.arteH);
      c.restore();

      /* Y encima el corte. El grosor y el rayado van en píxeles de pantalla
         (de ahí el /escala): en milímetros, la misma línea se ve fina en una
         pegatina de 10 cm y gordísima en una de 3, porque la previa siempre
         ocupa lo mismo y lo que cambia es la escala.
       *
       * `guias: false` pinta la pegatina a pelo, sin las dos líneas. Lo usan
       * las pruebas que cuentan tinta: el rayado rosa y su borde difuminado se
       * cuelan en el recuento y entonces la medida miente. */
      var px1 = 1 / escala;                            // un píxel de pantalla, en mm
      if (o.guias !== false) {
        c.strokeStyle = corte; c.lineWidth = 1.6 * px1;
        c.setLineDash([6 * px1, 4.5 * px1]);
        trazar(c, p, margen);
        c.stroke();
        c.setLineDash([]);
        /* zona de seguridad: por dentro, en gris, para que se entienda. En
           chapas no es el margen genérico de 2 mm de las pegatinas: es la
           zona de texto/diseño real de la ficha del proveedor (más estrecha
           cuanto más cerca del pliegue), así que el aro se calcula desde
           r.limiteChapa en vez de p.seguridad. */
        var segCh = (o.chapa && p.limiteChapa) ? (p.cutW - p.limiteChapa) / 2 : p.seguridad;
        c.strokeStyle = 'rgba(0,0,0,.28)'; c.lineWidth = px1;
        c.setLineDash([3 * px1, 3 * px1]);
        trazar(c, { forma: p.forma, cutW: p.cutW - 2 * segCh, cutH: p.cutH - 2 * segCh,
          radio: Math.max(0.6, Math.min(3, p.cutW / 4, p.cutH / 4) - segCh) }, margen + segCh);
        c.stroke();
        c.setLineDash([]);
      }
    }

    /* ---------- LAS COTAS, como en un plano ----------
     *
     * «¿y esto cuánto es?» es la pregunta que se hace todo el mundo mirando una
     * previa, y contestarla con un número al lado de la flecha ahorra la mitad
     * de los mensajes. En la ficha de transfers ya estaban; esto es traerlas a
     * pegatinas, que es donde el cliente compra POR TAMAÑO.
     *
     * Se mide LA PEGATINA, no el dibujo: lo que le va a llegar al buzón,
     * borde blanco incluido.
     *
     * Todo lo de aquí va en píxeles de pantalla (de ahí el `u`, que es un píxel
     * en milímetros): en mm, el mismo texto se vería diminuto en una pegatina
     * de 10 cm y enorme en una de 3, porque la previa siempre ocupa lo mismo y
     * lo que cambia es la escala. */
    if (o.cotas) {
      var u = 1 / escala;
      /* LA TINTA NO LA DECIDE EL TEMA, LA DECIDE EL LIENZO.
         Primero pinté esto mirando si la página era oscura, y con el tema
         oscuro salían flechas blancas y etiquetas negras... sobre el ajedrez
         CLARO de la previa, que es lo que hay detrás de verdad. Xavi lo vio
         enseguida. El ajedrez es claro siempre, así que la tinta es oscura
         siempre y la etiqueta, blanca. */
      var tinta = 'rgba(0,0,0,.82)';
      var suave = 'rgba(0,0,0,.3)';
      var fondoEti = '#ffffff';
      var x0 = margen, y0 = margen;

      c.save();
      c.lineJoin = 'round';
      /* El tema le pone letter-spacing a la página y Chrome se lo lleva al
         canvas: el «3 cm» salía como «3   c   m». Aquí se manda, no el tema. */
      if ('letterSpacing' in c) c.letterSpacing = '0px';
      c.strokeStyle = suave; c.lineWidth = 0.8 * u;
      c.beginPath();
      // los tirantes desde las esquinas de la pegatina hasta sus flechas
      c.moveTo(x0, y0 + p.cutH); c.lineTo(x0, y0 + p.cutH + 22 * u);
      c.moveTo(x0 + p.cutW, y0 + p.cutH); c.lineTo(x0 + p.cutW, y0 + p.cutH + 22 * u);
      c.moveTo(x0 + p.cutW, y0); c.lineTo(x0 + p.cutW + 22 * u, y0);
      c.moveTo(x0 + p.cutW, y0 + p.cutH); c.lineTo(x0 + p.cutW + 22 * u, y0 + p.cutH);
      c.stroke();

      c.strokeStyle = tinta; c.fillStyle = tinta;
      function flecha(ax, ay, bx, by) {
        c.lineWidth = 1.1 * u;
        c.beginPath(); c.moveTo(ax, ay); c.lineTo(bx, by); c.stroke();
        var d = Math.atan2(by - ay, bx - ax), q = 5 * u;
        [[ax, ay, d], [bx, by, d + Math.PI]].forEach(function (f) {
          c.beginPath();
          c.moveTo(f[0], f[1]);
          c.lineTo(f[0] + Math.cos(f[2] - 0.45) * q, f[1] + Math.sin(f[2] - 0.45) * q);
          c.moveTo(f[0], f[1]);
          c.lineTo(f[0] + Math.cos(f[2] + 0.45) * q, f[1] + Math.sin(f[2] + 0.45) * q);
          c.stroke();
        });
      }
      /* 18 px de separación, no 9. En una forma libre daba igual —el dibujo no
         llega a su propio rectángulo—, pero un CÍRCULO sí toca el rectángulo
         justo en el medio de cada lado, que es donde va la flecha: la cota se
         le pegaba al filo y parecía pegada con celo. */
      var yC = y0 + p.cutH + 18 * u, xC = x0 + p.cutW + 18 * u;
      flecha(x0, yC, x0 + p.cutW, yC);
      flecha(xC, y0, xC, y0 + p.cutH);

      c.font = 'bold ' + (12 * u) + 'px sans-serif';
      c.textAlign = 'center'; c.textBaseline = 'middle';
      function eti(txt, ex, ey) {
        var w = c.measureText(txt).width + 7 * u, h = 15 * u;
        c.fillStyle = fondoEti;
        c.fillRect(ex - w / 2, ey - h / 2, w, h);
        c.fillStyle = tinta;
        c.fillText(txt, ex, ey);
      }
      /* LAS CHAPAS SE COTAN EN MM DE VERDAD, NO EN CM (mismo motivo que en
         los botones de tamaño y el texto de medida): `cm()` divide entre 10
         asumiendo que ya vienen en mm-de-cm, y en chapas el mm es el número
         real. */
      var cotaTxt = o.chapa
        ? function (mm) { return Math.round(mm) + ' mm'; }
        : function (mm) { return cm(mm) + ' cm'; };
      eti(cotaTxt(p.cutW), x0 + p.cutW / 2, yC);
      c.translate(xC, y0 + p.cutH / 2);
      c.rotate(-Math.PI / 2);
      eti(cotaTxt(p.cutH), 0, 0);
      c.restore();
    }

    return { escala: escala, totalW: totalW, totalH: totalH };
  }

  // 30 -> "3", 29.03 -> "2,9": un decimal y solo si hace falta
  function cm(mm) {
    var v = Math.round(mm) / 10;
    return (v % 1 ? v.toFixed(1) : String(v)).replace('.', ',');
  }

  function trazar(c, p, m) {
    c.beginPath();
    if (p.forma === 'redonda') {
      c.arc(m + p.cutW / 2, m + p.cutH / 2, p.cutW / 2, 0, Math.PI * 2);
    } else {
      var r = p.radio != null ? p.radio : Math.min(3, p.cutW / 4, p.cutH / 4);
      var x = m, y = m, w = p.cutW, h = p.cutH;
      c.moveTo(x + r, y);
      c.arcTo(x + w, y, x + w, y + h, r);
      c.arcTo(x + w, y + h, x, y + h, r);
      c.arcTo(x, y + h, x, y, r);
      c.arcTo(x, y, x + w, y, r);
      c.closePath();
    }
  }

  window.PegatinaCorte = {
    BORDE: BORDE, BORDE_MIN: BORDE_MIN, SEGURIDAD: SEGURIDAD, bordePara: bordePara,
    formatoDe: formatoDe, plan: plan, dibujar: dibujar, porHoja: porHoja,
    casiTodoBlanco: casiTodoBlanco, silueta: silueta,
    /* píxeles de SOMBRA de un RGBA (para no contarlos al medir el dibujo): Uint8Array, 1 = sombra */
    sombraAlfa: function (d, w, h, r) {
      var m = new Uint8Array(w * h), fuera = new Uint8Array(w * h);
      for (var i = 0; i < m.length; i++) m[i] = d[i * 4 + 3] >= 8 ? 1 : 0;
      quitarSombraAlfa(m, d, w, h, Math.max(1, r || 3), fuera);
      return fuera;
    }
  };
})();